import React, { useId, useState } from 'react';
import PropTypes from 'prop-types';
import { Icon } from './Icon';
import './Disclosure.css';

/**
 * Collapsible disclosure panel (sharp corners, focus ring).
 */
export function Disclosure({
  title,
  children,
  defaultOpen = false,
  className = '',
  'data-testid': dataTestId,
}) {
  const [open, setOpen] = useState(defaultOpen);
  const panelId = useId();
  const headerId = `${panelId}-header`;

  return (
    <div
      className={['onyx-disclosure', open ? 'onyx-disclosure--open' : '', className].filter(Boolean).join(' ')}
      data-testid={dataTestId}
    >
      <button
        type="button"
        className="onyx-disclosure__trigger"
        aria-expanded={open}
        aria-controls={panelId}
        id={headerId}
        onClick={() => setOpen((prev) => !prev)}
      >
        <span className="onyx-disclosure__title">{title}</span>
        <Icon
          name={open ? 'expandLess' : 'expand'}
          className="onyx-disclosure__chevron"
          aria-hidden
        />
      </button>
      {open ? (
        <div
          id={panelId}
          role="region"
          aria-labelledby={headerId}
          className="onyx-disclosure__panel"
        >
          {children}
        </div>
      ) : null}
    </div>
  );
}

Disclosure.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
};
